import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { forwardRef, useEffect, useState } from 'react';
import { COLORS, DEFAULT_THEME } from "../../constants/Theme";
export const Switch = forwardRef(({ customThumbColor, trackColor, trackHeight, trackLength, disabled, value: propsValue, onValueChange, duration, containerStyle, type, isLoading, 'data-test': dataTest, }) => {
    var _a, _b, _c, _d;
    const { colorsV2 } = DEFAULT_THEME;
    const [value, setValue] = useState(propsValue);
    const [isloading, setLoading] = useState(isLoading !== null && isLoading !== void 0 ? isLoading : false);
    const durationTime = duration !== null && duration !== void 0 ? duration : 200;
    useEffect(() => {
        if (typeof isLoading == 'boolean') {
            setLoading(isLoading);
        }
    }, [isLoading]);
    useEffect(() => {
        setValue(propsValue);
    }, [propsValue]);
    const consolidatedTrackColor = disabled
        ? {
            false: colorsV2.background.inactive,
            true: colorsV2.background.inactive,
        }
        : {
            false: ((_a = trackColor === null || trackColor === void 0 ? void 0 : trackColor.false) !== null && _a !== void 0 ? _a : type === 'greenred')
                ? colorsV2.background.negative.light
                : colorsV2.background.base,
            true: ((_b = trackColor === null || trackColor === void 0 ? void 0 : trackColor.true) !== null && _b !== void 0 ? _b : type === 'greenred')
                ? colorsV2.background.positive.vibrant
                : colorsV2.background.brand,
        };
    const consolidatedBorderColor = {
        false: type === 'greenred'
            ? colorsV2.stroke.negative.lightAlt
            : colorsV2.stroke.primary,
        true: type === 'greenred'
            ? colorsV2.background.positive.vibrant
            : colorsV2.background.brand,
    };
    const consolidatedThumbColor = disabled
        ? { false: colorsV2.content.inactive, true: colorsV2.content.inactive }
        : {
            false: ((_c = customThumbColor === null || customThumbColor === void 0 ? void 0 : customThumbColor.false) !== null && _c !== void 0 ? _c : type === 'greenred')
                ? colorsV2.content.negative
                : colorsV2.text.primary,
            true: (_d = customThumbColor === null || customThumbColor === void 0 ? void 0 : customThumbColor.true) !== null && _d !== void 0 ? _d : colorsV2.surface.standard,
        };
    const consolidateOutlineColor = !type
        ? { false: colorsV2.stroke.primary, true: colorsV2.stroke.primary }
        : {
            false: type === 'greenred'
                ? colorsV2.stroke.negative.lightAlt
                : colorsV2.stroke.primary,
            true: type === 'greenred'
                ? colorsV2.stroke.positive.lightAlt
                : colorsV2.background.brandLight,
        };
    function handlePress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (disabled) {
                return;
            }
            if (typeof isLoading !== 'boolean') {
                setLoading(true);
            }
            try {
                yield (onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(!value));
                setValue(!value);
            }
            catch (err) {
                console.log(err);
            }
            if (typeof isLoading !== 'boolean') {
                setLoading(false);
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsx(SwitchContainer, Object.assign({ "data-test": dataTest, trackLength: trackLength !== null && trackLength !== void 0 ? trackLength : 40, trackHeight: trackHeight !== null && trackHeight !== void 0 ? trackHeight : 20, onClick: () => handlePress(), trackColor: consolidatedTrackColor, value: value, style: containerStyle, borderColor: consolidatedBorderColor, duration: durationTime, disabled: disabled, outlineColor: consolidateOutlineColor }, { children: isloading ? (_jsx(Loader, { value: value, trackColor: consolidatedTrackColor })) : (_jsx(Thumb, { value: value, duration: durationTime, thumbColor: consolidatedThumbColor })) })) }));
});
Switch.displayName = 'Switch';
export const SwitchContainer = styled.div `
	display: flex;
	flex-direction: row;
	margin-top: 5px;
	margin-bottom: 5px;
	border-radius: 30px;
	background-color: red;
	background-color: ${(props) => props.value ? props.trackColor.true : props.trackColor.false};
	width: ${(props) => props.trackLength + 'px'};
	height: ${(props) => props.trackHeight + 'px'};
	border-width: ${(props) => (props.disabled ? '0px' : '1px')};
	border-style: solid;
	border-color: ${(props) => props.value ? props.borderColor.true : props.borderColor.false};

	transition: ${(props) => `${props.duration / 1000}s ease all`};
	align-items: center;
	cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
	:focus {
		outline: ${(props) => props.value ? props.outlineColor.true : props.outlineColor.false};
		outline-style: solid;
		outline-offset: 2px;
		outline-width: 2px;
	}
	:active {
		outline: ${(props) => props.value ? props.outlineColor.true : props.outlineColor.false};
		outline-style: solid;
		outline-offset: 2px;
		outline-width: 2px;
	}
`;
export const Thumb = styled.div `
	height: 12px;
	width: 12px;
	margin: 4px;
	border-radius: 8px;
	position: relative;
	left: ${(props) => (props.value ? 'calc(100% - 20px)' : '0px')};
	transition: ${(props) => `${props.duration / 1000}s ease all`};
	background-color: ${(props) => props.value ? props.thumbColor.true : props.thumbColor.false};
`;
export const Loader = styled.div `
	border-width: 2px;
	border-style: solid;
	border-color: ${(props) => props.value ? props.trackColor.true : props.trackColor.false};
	border-top-width: 2px;
	border-top-style: solid;
	border-top-color: ${(props) => props.value ? COLORS.text.white : COLORS.background.brand};
	border-radius: 50%;
	height: 8px;
	width: 8px;
	margin: 4px;
	position: relative;
	left: ${(props) => (props.value ? 'calc(100% - 20px)' : '0px')};
	animation: spin 1s linear infinite;
	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;
//# sourceMappingURL=Switch.js.map